import { useState, useEffect } from "react"
import logo from "../images/brand/logo.png";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faWallet, faCreditCard, faUser, faUsers, faCircleNotch} from '@fortawesome/free-solid-svg-icons'
import { faCircleCheck } from "@fortawesome/free-regular-svg-icons";
import { Toaster, toast } from 'react-hot-toast';
import { useNavigate, Link, useLocation } from 'react-router-dom'
import { formatCurrency } from '../utils/currencyUtils';

function Enrollment4() {
  const navigate = useNavigate();
  const { state } = useLocation();
  const [loading, setLoading] = useState(true);
  const [loading1, setLoading1] = useState(false);
  const [employer_id, setEmployer_id] = useState(state?.employer_id ?? localStorage.getItem('user.employer_id') ?? '');
  const [age, setAge] = useState(state?.age ?? localStorage.getItem('user.age') ?? '');
  const [contribution, setContribution] = useState(state?.contribution ?? localStorage.getItem('user.contribution') ?? '');
  const [salary, setSalary] = useState(state?.salary ?? localStorage.getItem('user.salary') ?? '');
  const [tax_type, setTax_type] = useState(state?.tax_type ?? localStorage.getItem('user.tax_type') ?? 'Pre-tax');
  const [effective_date, setEffective_date] = useState(state?.effective_date ?? localStorage.getItem('user.effective_date') ?? 'false');
  const [investment, setInvestment] = useState(state?.investment ?? localStorage.getItem('user.investment') ?? 'target');
  const [stocks, setStocks] = useState(state?.stocks ?? localStorage.getItem('user.stocks') ?? 60);
  const [bonds, setBonds] = useState(state?.bonds ?? localStorage.getItem('user.bonds') ?? 30);
  const [cash, setCash] = useState(state?.cash ?? localStorage.getItem('user.cash') ?? 10);
  const [relationship, setRelationship] = useState(state?.relationship ?? localStorage.getItem('user.relationship') ?? 'Spouse');
  const [share, setShare] = useState(state?.share ?? localStorage.getItem('user.share') ?? 100);
  const [beneficiary_name, setBeneficiary_name] = useState(state?.beneficiary_name ?? localStorage.getItem('user.beneficiary_name') ?? '');
  const [email, setEmail] = useState(localStorage.getItem('user.email') ?? '');
  const [userDetails, setUserDetails] = useState([]);
  useEffect(() => {
    if(!beneficiary_name || !share || !relationship){
        navigate('/enrollment3', { replace: true });
    }else{
        setLoading(false)
    }
  }, [email]);
  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}controller/login.controller.php`, {
      credentials: "include",
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ fetchuser1: true, email: email})
    })
    .then(response => response.json())
    .then(data => {
      if (data.status === "success" && data.user) {
            setUserDetails(data.user);
            setLoading(false);
        } else {
            setLoading(true);
        }
    })
    .catch(err => {
      console.error(err)
      setLoading(false);
    })
  }, [email]);

  const ValidateEnrollment = () =>{
    setLoading1(true);
    fetch(`${process.env.REACT_APP_API_URL}controller/login.controller.php`, {
        credentials: "include",
        method: "POST",
        headers: {
        "Content-Type": "application/json"
        },
        body: JSON.stringify({ btn_enroll: true, employer_id: employer_id, age: age, contribution: contribution, salary: salary, tax_type: tax_type, effective_date: effective_date, stocks: stocks, bonds: bonds, cash: cash, relationship: relationship, share: share, beneficiary_name: beneficiary_name, email: email })
    })
    .then(response => response.json())
    .then(data => {
        console.log(data);
        if (data.status === "success") {
            setLoading1(false);
            toast.success(data.result);
            setTimeout(() => {
                navigate('/login', { replace: true, state: { verify: true, email : email } });
            }, 2000);
        } else {
            toast.error(data.message); 
            setLoading1(false);
        }
    })
    .catch(err => {
        console.error(err)
        setLoading1(false);
    })
  }

  if (loading || !userDetails || typeof userDetails !== 'object' || Object.keys(userDetails).length === 0) {
    return <div style={{ textAlign: "center", marginTop: "20%" }}><FontAwesomeIcon icon={faCircleNotch} style={{fontSize: '30px', color: '#ff6b35', opacity: '0.5'}} spin /></div>;
  }

  return (
    <div className="min-vh-100 d-flex flex-column text-white" style={{backgroundColor: 'rgb(5, 8, 11)', padding: '0px 32px 144px'}}>
    <div><Toaster/></div>
    <header className="d-flex align-items-center justify-content-between" style={{padding: '32px 0px'}}>
        <img src={logo} alt="logo" className="app-logo"/>
        <Link to="/" className="text-light text-decoration-none" style={{fontSize: '14px'}}>
        Back to homepage
        </Link>
    </header>
    <main>
        <div className="container mt-5">
            <div className="row">
                <div className="col-lg-8 offset-lg-2 mb-5">
                    <h5 className="mb-0" style={{fontWeight:'900'}}>401(k) Enrollment</h5>
                    <div className="mt-5 d-flex align-items-center progressD" style={{gap:'20px'}}>
                      <Link to="/enrollment" className="d-flex flex-column align-items-center noLink">
                          <div className="rounded-circle d-flex align-items-center justify-content-center bg-prime" style={{minHeight:'50px',minWidth:'50px',width:'50px',height:'50px'}}>
                          <FontAwesomeIcon icon={faUser} style={{fontSize: '16px'}} />
                          </div>
                          <p className="mb-0 fw-semibold mt-1 text-prime text-nowrap" style={{fontSize:'12px'}}>Personal</p>
                      </Link>
                      <div className="bg-prime" style={{height:'3px',maxWidth:'200px',width:'100%'}}></div>
                      <Link to="/enrollment1" className="d-flex flex-column align-items-center noLink">
                          <div className="rounded-circle d-flex align-items-center justify-content-center bg-prime" style={{minHeight:'50px',minWidth:'50px',width:'50px',height:'50px',backgroundColor:'#ffffff0c'}}>
                          <FontAwesomeIcon icon={faWallet} style={{fontSize: '16px'}} />
                          </div>
                          <p className="mb-0 fw-semibold mt-1 text-nowrap text-prime" style={{fontSize:'12px'}}>Contributions</p>
                      </Link>
                      <div className="bg-prime" style={{height:'3px',maxWidth:'200px',width:'100%'}}></div>
                      <Link to="/enrollment2" className="d-flex flex-column align-items-center noLink">
                          <div className="rounded-circle d-flex align-items-center justify-content-center bg-prime" style={{minHeight:'50px',minWidth:'50px',width:'50px',height:'50px',backgroundColor:'#ffffff0c'}}>
                          <FontAwesomeIcon icon={faCreditCard} style={{fontSize: '16px'}} />
                          </div>
                          <p className="mb-0 fw-semibold mt-1 text-nowrap text-prime" style={{fontSize:'12px'}}>Investment</p>
                      </Link>
                      <div className="bg-prime" style={{height:'3px',maxWidth:'200px',width:'100%'}}></div>
                      <Link to="/enrollment3" className="d-flex flex-column align-items-center noLink">
                          <div className="rounded-circle d-flex align-items-center justify-content-center bg-prime" style={{minHeight:'50px',minWidth:'50px',width:'50px',height:'50px',backgroundColor:'#ffffff0c'}}>
                          <FontAwesomeIcon icon={faUsers} style={{fontSize: '16px'}} />
                          </div>
                          <p className="mb-0 fw-semibold mt-1 text-nowrap text-prime" style={{fontSize:'12px'}}>Beneficiary</p>
                      </Link>
                      <div className="bg-prime" style={{height:'3px',maxWidth:'200px',width:'100%'}}></div>
                      <Link to="/enrollment4" className="d-flex flex-column align-items-center noLink">
                          <div className="rounded-circle d-flex align-items-center justify-content-center bg-prime" style={{minHeight:'50px',minWidth:'50px',width:'50px',height:'50px',backgroundColor:'#ffffff0c'}}>
                          <FontAwesomeIcon icon={faCircleCheck} style={{fontSize: '16px'}} />
                          </div>
                          <p className="mb-0 fw-semibold mt-1 text-nowrap text-prime" style={{fontSize:'12px'}}>Review</p>
                      </Link>
                    </div>
                    <div className="mycard p-3 mt-4">
                        <div className="col-12 largeSelect">
                            <h5 className="mb-4" style={{fontWeight:'900'}}>Review & Confirm</h5>
                            <div className="mb-4 mycard p-3">
                                <div className="d-flex align-items-center justify-content-between mb-3" style={{gap:'10px'}}>
                                    <p className="mb-0 text-secondary fw-semibold">Name</p>
                                    <p className="mb-0 fw-bold text-end">{userDetails?.fullname}</p>
                                </div>
                                <div className="d-flex align-items-center justify-content-between mb-3" style={{gap:'10px'}}>
                                    <p className="mb-0 text-secondary fw-semibold">Contribution </p>
                                    <p className="mb-0 fw-bold text-end">{formatCurrency(contribution)}% ({tax_type})</p>
                                </div>
                                <div className="d-flex align-items-center justify-content-between mb-3" style={{gap:'10px'}}>
                                    <p className="mb-0 text-secondary fw-semibold">Investments </p>
                                    <p className="mb-0 fw-bold text-end">{stocks}% Stocks, {bonds}% Bonds, {cash}% Cash</p>
                                </div>
                                <div className="d-flex align-items-center justify-content-between mb-3" style={{gap:'10px'}}>
                                    <p className="mb-0 text-secondary fw-semibold">Beneficiary </p>
                                    <p className="mb-0 fw-bold text-end">{beneficiary_name} — {relationship} ({share}%)</p>
                                </div>
                            </div>
                            <div className="mycard p-3 rounded-2" style={{backgroundColor:'#ff6b350d'}}>
                                <p className="mb-0 text-prime" style={{fontSize:'14px'}}>By submitting you agree to payroll deduction and plan terms.</p>
                            </div>
                            <hr/>
                            <div className="d-flex justify-content-end">
                                <div className="myBtn mt-4 text-center px-4 py-3 rounded-2 d-block" onClick={ValidateEnrollment}>{loading1?<FontAwesomeIcon icon={faCircleNotch} style={{fontSize: '20px', color: 'white', opacity: '0.5'}} spin />:'Submit'}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </main>
    </div>
  )
}

export default Enrollment4